
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about_45us9kiw2OpfgnMeta } from "/opt/build/repo/pages/about-us.vue?macro=true";
import { default as are_45you_45an_45agencyDKOlJF2RdSMeta } from "/opt/build/repo/pages/are-you-an-agency.vue?macro=true";
import { default as indexx3sznPgcaVMeta } from "/opt/build/repo/pages/blog/[slug]/index.vue?macro=true";
import { default as indexmFsYN4t0XfMeta } from "/opt/build/repo/pages/blog/index.vue?macro=true";
import { default as indexXg4YC5iHhmMeta } from "/opt/build/repo/pages/careers/[slug]/index.vue?macro=true";
import { default as indexxwcF5y3IQqMeta } from "/opt/build/repo/pages/careers/index.vue?macro=true";
import { default as clinical_45areashjSfAxVoH6Meta } from "/opt/build/repo/pages/clinical-areas.vue?macro=true";
import { default as contactsQ2Ks7vPefgMeta } from "/opt/build/repo/pages/contacts.vue?macro=true";
import { default as indexSTbUvLZXiaMeta } from "/opt/build/repo/pages/contents/[slug]/index.vue?macro=true";
import { default as indexvKm4H3ohfUMeta } from "/opt/build/repo/pages/contents/index.vue?macro=true";
import { default as cookie_45policyZcRIsfqfIvMeta } from "/opt/build/repo/pages/cookie-policy.vue?macro=true";
import { default as indexQVKfM23LXdMeta } from "/opt/build/repo/pages/expertise/[slug]/index.vue?macro=true";
import { default as indexuZ1vNkriiyMeta } from "/opt/build/repo/pages/expertise/index.vue?macro=true";
import { default as form_45submission_45failureddjxJla3GJMeta } from "/opt/build/repo/pages/form-submission-failure.vue?macro=true";
import { default as form_45submission_45successk0ay3CQ3szMeta } from "/opt/build/repo/pages/form-submission-success.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as indexfqhiJ6ICreMeta } from "/opt/build/repo/pages/industries/[slug]/index.vue?macro=true";
import { default as indexxQdX3kdZZvMeta } from "/opt/build/repo/pages/industries/index.vue?macro=true";
import { default as indexlrvF1FAyXbMeta } from "/opt/build/repo/pages/lets-talk/index.vue?macro=true";
import { default as indexR6jRtXNCEVMeta } from "/opt/build/repo/pages/listing/category/index.vue?macro=true";
import { default as sub_45category1jkZsvksYBMeta } from "/opt/build/repo/pages/listing/category/sub-category.vue?macro=true";
import { default as index42k9yu60GfMeta } from "/opt/build/repo/pages/listing/index.vue?macro=true";
import { default as newsletter_45submission_45successlNdcLQOt6WMeta } from "/opt/build/repo/pages/newsletter-submission-success.vue?macro=true";
import { default as privacy_45policyQXTlhFuZ55Meta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as indexBmiOq17LApMeta } from "/opt/build/repo/pages/projects/[slug]/index.vue?macro=true";
import { default as indexxtMqaql9AYMeta } from "/opt/build/repo/pages/projects/index.vue?macro=true";
import { default as richiedi_45progetto1Nn9GbgCcAMeta } from "/opt/build/repo/pages/richiedi-progetto.vue?macro=true";
import { default as index8lXtsvPro8Meta } from "/opt/build/repo/pages/solutions/[slug]/index.vue?macro=true";
import { default as indexSicrNAjcMxMeta } from "/opt/build/repo/pages/solutions/index.vue?macro=true";
import { default as indexuoDA5dcWGeMeta } from "/opt/build/repo/pages/technology/[slug]/index.vue?macro=true";
import { default as indexicFcACNNRXMeta } from "/opt/build/repo/pages/technology/index.vue?macro=true";
import { default as component_45stubelhfWzQBcmMeta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.17.19_db0@0.2.4_eslint@8.57.1_ioredis@_4d9b027392e088444a670ffc9c24b1f8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubelhfWzQBcm } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@20.17.19_db0@0.2.4_eslint@8.57.1_ioredis@_4d9b027392e088444a670ffc9c24b1f8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about-us___en",
    path: "/about-us",
    meta: about_45us9kiw2OpfgnMeta || {},
    component: () => import("/opt/build/repo/pages/about-us.vue")
  },
  {
    name: "about-us___it",
    path: "/it/studio",
    meta: about_45us9kiw2OpfgnMeta || {},
    component: () => import("/opt/build/repo/pages/about-us.vue")
  },
  {
    name: "are-you-an-agency___en",
    path: "/collaborations",
    meta: are_45you_45an_45agencyDKOlJF2RdSMeta || {},
    component: () => import("/opt/build/repo/pages/are-you-an-agency.vue")
  },
  {
    name: "are-you-an-agency___it",
    path: "/it/collaborazioni-tra-agenzie",
    meta: are_45you_45an_45agencyDKOlJF2RdSMeta || {},
    component: () => import("/opt/build/repo/pages/are-you-an-agency.vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    meta: indexx3sznPgcaVMeta || {},
    component: () => import("/opt/build/repo/pages/blog/[slug]/index.vue")
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    meta: indexx3sznPgcaVMeta || {},
    component: () => import("/opt/build/repo/pages/blog/[slug]/index.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    meta: indexmFsYN4t0XfMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue")
  },
  {
    name: "blog___it",
    path: "/it/blog",
    meta: indexmFsYN4t0XfMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue")
  },
  {
    name: "careers-slug___en",
    path: "/careers/:slug()",
    meta: indexXg4YC5iHhmMeta || {},
    component: () => import("/opt/build/repo/pages/careers/[slug]/index.vue")
  },
  {
    name: "careers-slug___it",
    path: "/it/careers/:slug()",
    meta: indexXg4YC5iHhmMeta || {},
    component: () => import("/opt/build/repo/pages/careers/[slug]/index.vue")
  },
  {
    name: "careers___en",
    path: "/careers",
    meta: indexxwcF5y3IQqMeta || {},
    component: () => import("/opt/build/repo/pages/careers/index.vue")
  },
  {
    name: "careers___it",
    path: "/it/careers",
    meta: indexxwcF5y3IQqMeta || {},
    component: () => import("/opt/build/repo/pages/careers/index.vue")
  },
  {
    name: "clinical-areas___en",
    path: "/clinical-areas",
    meta: clinical_45areashjSfAxVoH6Meta || {},
    component: () => import("/opt/build/repo/pages/clinical-areas.vue")
  },
  {
    name: "clinical-areas___it",
    path: "/it/aree-terapeutiche",
    meta: clinical_45areashjSfAxVoH6Meta || {},
    component: () => import("/opt/build/repo/pages/clinical-areas.vue")
  },
  {
    name: "contacts___en",
    path: "/contacts",
    meta: contactsQ2Ks7vPefgMeta || {},
    component: () => import("/opt/build/repo/pages/contacts.vue")
  },
  {
    name: "contacts___it",
    path: "/it/contatti",
    meta: contactsQ2Ks7vPefgMeta || {},
    component: () => import("/opt/build/repo/pages/contacts.vue")
  },
  {
    name: "contents-slug___en",
    path: "/contents/:slug()",
    meta: indexSTbUvLZXiaMeta || {},
    component: () => import("/opt/build/repo/pages/contents/[slug]/index.vue")
  },
  {
    name: "contents-slug___it",
    path: "/it/contenuti/:slug()",
    meta: indexSTbUvLZXiaMeta || {},
    component: () => import("/opt/build/repo/pages/contents/[slug]/index.vue")
  },
  {
    name: "contents___en",
    path: "/contents",
    meta: indexvKm4H3ohfUMeta || {},
    component: () => import("/opt/build/repo/pages/contents/index.vue")
  },
  {
    name: "contents___it",
    path: "/it/contenuti",
    meta: indexvKm4H3ohfUMeta || {},
    component: () => import("/opt/build/repo/pages/contents/index.vue")
  },
  {
    name: "cookie-policy___en",
    path: "/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___it",
    path: "/it/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue")
  },
  {
    name: "expertise-slug___en",
    path: "/expertise/:slug()",
    meta: indexQVKfM23LXdMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/[slug]/index.vue")
  },
  {
    name: "expertise-slug___it",
    path: "/it/expertise/:slug()",
    meta: indexQVKfM23LXdMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/[slug]/index.vue")
  },
  {
    name: "expertise___en",
    path: "/expertise",
    meta: indexuZ1vNkriiyMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/index.vue")
  },
  {
    name: "expertise___it",
    path: "/it/expertise",
    meta: indexuZ1vNkriiyMeta || {},
    component: () => import("/opt/build/repo/pages/expertise/index.vue")
  },
  {
    name: "form-submission-failure___en",
    path: "/form-submission-failure",
    meta: form_45submission_45failureddjxJla3GJMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-failure.vue")
  },
  {
    name: "form-submission-failure___it",
    path: "/it/form-submission-failure",
    meta: form_45submission_45failureddjxJla3GJMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-failure.vue")
  },
  {
    name: "form-submission-success___en",
    path: "/form-submission-success",
    meta: form_45submission_45successk0ay3CQ3szMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-success.vue")
  },
  {
    name: "form-submission-success___it",
    path: "/it/form-submission-success",
    meta: form_45submission_45successk0ay3CQ3szMeta || {},
    component: () => import("/opt/build/repo/pages/form-submission-success.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "industries-slug___en",
    path: "/industries/:slug()",
    meta: indexfqhiJ6ICreMeta || {},
    component: () => import("/opt/build/repo/pages/industries/[slug]/index.vue")
  },
  {
    name: "industries-slug___it",
    path: "/it/settori/:slug()",
    meta: indexfqhiJ6ICreMeta || {},
    component: () => import("/opt/build/repo/pages/industries/[slug]/index.vue")
  },
  {
    name: "industries___en",
    path: "/industries",
    meta: indexxQdX3kdZZvMeta || {},
    component: () => import("/opt/build/repo/pages/industries/index.vue")
  },
  {
    name: "industries___it",
    path: "/it/settori",
    meta: indexxQdX3kdZZvMeta || {},
    component: () => import("/opt/build/repo/pages/industries/index.vue")
  },
  {
    name: "lets-talk___en",
    path: "/lets-talk",
    meta: indexlrvF1FAyXbMeta || {},
    component: () => import("/opt/build/repo/pages/lets-talk/index.vue")
  },
  {
    name: "lets-talk___it",
    path: "/it/lets-talk",
    meta: indexlrvF1FAyXbMeta || {},
    component: () => import("/opt/build/repo/pages/lets-talk/index.vue")
  },
  {
    name: "listing-category___en",
    path: "/listing/category",
    meta: indexR6jRtXNCEVMeta || {},
    component: () => import("/opt/build/repo/pages/listing/category/index.vue")
  },
  {
    name: "listing-category___it",
    path: "/it/listing/category",
    meta: indexR6jRtXNCEVMeta || {},
    component: () => import("/opt/build/repo/pages/listing/category/index.vue")
  },
  {
    name: "listing-category-sub-category___en",
    path: "/listing/category/sub-category",
    meta: sub_45category1jkZsvksYBMeta || {},
    component: () => import("/opt/build/repo/pages/listing/category/sub-category.vue")
  },
  {
    name: "listing-category-sub-category___it",
    path: "/it/listing/category/sub-category",
    meta: sub_45category1jkZsvksYBMeta || {},
    component: () => import("/opt/build/repo/pages/listing/category/sub-category.vue")
  },
  {
    name: "listing___en",
    path: "/listing",
    meta: index42k9yu60GfMeta || {},
    component: () => import("/opt/build/repo/pages/listing/index.vue")
  },
  {
    name: "listing___it",
    path: "/it/listing",
    meta: index42k9yu60GfMeta || {},
    component: () => import("/opt/build/repo/pages/listing/index.vue")
  },
  {
    name: "newsletter-submission-success___en",
    path: "/newsletter-submission-success",
    meta: newsletter_45submission_45successlNdcLQOt6WMeta || {},
    component: () => import("/opt/build/repo/pages/newsletter-submission-success.vue")
  },
  {
    name: "newsletter-submission-success___it",
    path: "/it/newsletter-submission-success",
    meta: newsletter_45submission_45successlNdcLQOt6WMeta || {},
    component: () => import("/opt/build/repo/pages/newsletter-submission-success.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "projects-slug___en",
    path: "/projects/:slug()",
    meta: indexBmiOq17LApMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[slug]/index.vue")
  },
  {
    name: "projects-slug___it",
    path: "/it/projects/:slug()",
    meta: indexBmiOq17LApMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[slug]/index.vue")
  },
  {
    name: "projects___en",
    path: "/projects",
    meta: indexxtMqaql9AYMeta || {},
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "projects___it",
    path: "/it/projects",
    meta: indexxtMqaql9AYMeta || {},
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "richiedi-progetto___en",
    path: "/contacts/start-new-project",
    meta: richiedi_45progetto1Nn9GbgCcAMeta || {},
    component: () => import("/opt/build/repo/pages/richiedi-progetto.vue")
  },
  {
    name: "richiedi-progetto___it",
    path: "/it/contatti/richiedi-un-progetto",
    meta: richiedi_45progetto1Nn9GbgCcAMeta || {},
    component: () => import("/opt/build/repo/pages/richiedi-progetto.vue")
  },
  {
    name: "solutions-slug___en",
    path: "/solutions/:slug()",
    meta: index8lXtsvPro8Meta || {},
    component: () => import("/opt/build/repo/pages/solutions/[slug]/index.vue")
  },
  {
    name: "solutions-slug___it",
    path: "/it/soluzioni/:slug()",
    meta: index8lXtsvPro8Meta || {},
    component: () => import("/opt/build/repo/pages/solutions/[slug]/index.vue")
  },
  {
    name: "solutions___en",
    path: "/solutions",
    meta: indexSicrNAjcMxMeta || {},
    component: () => import("/opt/build/repo/pages/solutions/index.vue")
  },
  {
    name: "solutions___it",
    path: "/it/soluzioni",
    meta: indexSicrNAjcMxMeta || {},
    component: () => import("/opt/build/repo/pages/solutions/index.vue")
  },
  {
    name: "technology-slug___en",
    path: "/technology/:slug()",
    meta: indexuoDA5dcWGeMeta || {},
    component: () => import("/opt/build/repo/pages/technology/[slug]/index.vue")
  },
  {
    name: "technology-slug___it",
    path: "/it/technology/:slug()",
    meta: indexuoDA5dcWGeMeta || {},
    component: () => import("/opt/build/repo/pages/technology/[slug]/index.vue")
  },
  {
    name: "technology___en",
    path: "/technology",
    meta: indexicFcACNNRXMeta || {},
    component: () => import("/opt/build/repo/pages/technology/index.vue")
  },
  {
    name: "technology___it",
    path: "/it/technology",
    meta: indexicFcACNNRXMeta || {},
    component: () => import("/opt/build/repo/pages/technology/index.vue")
  },
  {
    name: component_45stubelhfWzQBcmMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubelhfWzQBcm
  }
]